// extracted by mini-css-extract-plugin
module.exports = {"reviewsWrapper":"iq","columnsWrapper":"ir","reviewsHeader":"is","reviews":"it"};